module.exports = __webpack_public_path__ + "media/images/icons/outlined/user-delete-fcf0b102a744d85fdcf0478dec8fcc33.svg";